interface SvgIconProps {
  markup: string;
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function SvgIcon({
  markup,
  className,
  size = 24,
  strokeWidth,
}: SvgIconProps) {
  const resolved = strokeWidth
    ? markup.replace(/stroke-width="[0-9.]+"/, `stroke-width="${strokeWidth}"`)
    : markup;
  return (
    <span
      aria-hidden
      className={className}
      style={{ width: size, height: size, display: "inline-block" }}
      dangerouslySetInnerHTML={{ __html: resolved }}
    />
  );
}
